import { Link } from 'react-router';
import styled from 'styled-components';

import { BREAKPOINTS, COLORS } from 'utils/constants.js';

export default styled(Link)`
    transition: background-color .1s;
    position: relative;
    display: block;
    height: 3.5rem;
    width: 3.5rem;
    background: transparent;
    
    svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 1.25rem;
    }
    
    path,
    circle {
        transition: fill .1s;
        fill: ${COLORS.siteLightBlue};
    }
    
    &:hover {
        background: ${COLORS.siteDarkBlue};
        path,
        circle {
            fill: white;
        }
    }
    
    &.active {
        background: ${COLORS.siteDarkBlue};
        path,
        circle {
            fill: white;
        }
    }
    
    &.logout-link {
        position: absolute;
        left: 0;
        bottom: 0;
    }
    
    @media screen and (min-width: ${BREAKPOINTS.smallTabletBreakpoint}) {
        height: 5.25rem;
        width: 5.25rem;
        
        svg {
            width: 1.75rem;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/MainNav/MainNavLink.js